import { API_URL } from "config";
import Http from "util/https";

/**
 * ダウンロードするURLを取得
 * @param filePath ファイルパス
 */
export default async function downloadHelpPdf(filePath: string) {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/pdf/document/download`;
  const res = await http.post(url, {file_path: filePath});
  console.log(res.data);

  // const res: {data: {url: string}} = {data: {url: 'https://sample-videos.com/csv/Sample-Spreadsheet-10-rows.csv'}}

  return res.data.url;
}